import { createContext } from "react";

import { PatientType } from "@/domain/patients";

export const CurrentPatientContext = createContext<PatientType | null>(null);
